import {withStyles, Select} from "@material-ui/core";

const BoxSelect = withStyles((theme) => ({
    root: {
        position: 'relative',
        backgroundColor: theme.palette.common.white,
        border: '1.4px solid #BBBED7',
        fontSize: 16,
        display: 'block',
        marginTop: 10,
        padding: '10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        boxShadow: '0px 3px 16px rgba(74, 168, 221, 0.13)',
        borderRadius: 2,
    },
}))(Select);

export default BoxSelect;